var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { settingsActions } from './types';
export var defaultSettingsData = {
    version: 1,
    pageTitle: '',
};
export var defaultSettingsState = {
    isFetching: false,
    error: undefined,
    data: defaultSettingsData,
    ui: {
        blockLibrary: false,
        palette: false
    }
};
export var settingsReducer = function (state, action) {
    var _a;
    switch (action.type) {
        case settingsActions.FETCH:
            return __assign(__assign({}, state), { isFetching: true });
        case settingsActions.SUCCESS:
            return __assign(__assign({}, state), { data: __assign({}, action.data), isFetching: false });
        case settingsActions.FAILURE:
            return __assign(__assign({}, state), { error: action.error, isFetching: false });
        case settingsActions.UPDATE:
            return __assign(__assign({}, state), { data: __assign(__assign({}, state.data), action.data) });
        case settingsActions.DEFAULT:
            return __assign(__assign({}, state), defaultSettingsState);
        case settingsActions.TOGGLE_UI:
            return __assign(__assign({}, state), { ui: __assign(__assign({}, state.ui), (_a = {}, _a[action.data.property] = action.data.value, _a)) });
        default:
            throw new Error("Unhandled action: " + action);
    }
};
